var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.242,
    height: 24,
    fill: "#024EA2",
    viewBox: "0 0 16.242 16.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "study--next",
    transform: "translate(-1.9 -1.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21301",
    "data-name": "Path 21301",
    d: "M23.317,15.857l3.469-3.429L23.317,9l-.817.806,2.651,2.623L22.5,15.051Z",
    transform: "translate(-8.786 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21302",
    "data-name": "Path 21302",
    d: "M9,3.143A2.857,2.857,0,1,1,6.143,6,2.857,2.857,0,0,1,9,3.143M9,2a4,4,0,1,0,4,4A4,4,0,0,0,9,2Z",
    transform: "translate(-1.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21303",
    "data-name": "Path 21303",
    d: "M13.429,24.857H12.286V22a2.857,2.857,0,0,0-2.857-2.857H6A2.857,2.857,0,0,0,3.143,22v2.857H2V22a4,4,0,0,1,4-4H9.429a4,4,0,0,1,4,4Z",
    transform: "translate(0 -6.857)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.a923421a2478735aa559fca4c9033c33.svg";
export { ForwardRef as ReactComponent };